import { statusEnum } from '../../enums/ProductEnums';
import { FlippingData } from '../views/FlippingData';
import { AttributeDTO } from './AttributeDTO';
import { CollisionDescriptorDTO } from './CollisionDescriptorDTO';
import { LocalizedTextDTO } from './LocalizedTextDTO';
import { MovementDataDTO } from './MovementDataDTO';
import { ProductBlueprintVisibilityDTO } from './ProductBlueprintVisibilityDTO';
import { ProductRelationshipGroupDTO } from './ProductRelationshipGroupDTO';

export interface ReceiptSettings {
  showOnReceipt: boolean;
}
export class ProductBlueprintDTO {
  id?: number;
  dimensions: number[] | null;
  modelUrl: string | null = null;
  thumbnailUrl: string;
  infoText: LocalizedTextDTO[];
  name: LocalizedTextDTO[];
  attributes: AttributeDTO[];
  productRelationshipGroups: ProductRelationshipGroupDTO[];
  externalId: string;
  flippingAxis: FlippingData | null;
  basePrice: number;
  movementData: MovementDataDTO;
  tlorisPlaceholderIcon?: string;
  collisionDescriptors?: CollisionDescriptorDTO[];
  rotateStep?: number;
  possibleRotations?: number[];
  builderName?: string;
  jsonData?: string;
  utilityIds?: number[];
  parameters?: string;
  status?: statusEnum;
  receiptSettings?: ReceiptSettings;
  productBlueprintVisibility: ProductBlueprintVisibilityDTO | null;

  constructor(
    id: number | undefined,
    name: LocalizedTextDTO[],
    dimensions: number[] | null = null,
    modelURL: string | null,
    thumbnailURL: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[] = [],
    productRelationshipGroups: ProductRelationshipGroupDTO[] = [],
    externalId: string,
    flippingAxis: FlippingData | null = null,
    basePrice: number,
    movementDatas: MovementDataDTO,
    tlorisPlaceholderIcon?: string,
    collisionDescriptors?: CollisionDescriptorDTO[],
    rotateStep?: number,
    possibleRotations?: number[],
    builderName?: string,
    jsonData?: string,
    utilityIds?: number[],
    parameters?: string,
    status?: statusEnum,
    receiptSettings?: ReceiptSettings,
    productBlueprintVisibility: ProductBlueprintVisibilityDTO | null = null,
  ) {
    this.id = id;
    this.name = name;
    this.dimensions = dimensions;
    this.modelUrl = modelURL;
    this.thumbnailUrl = thumbnailURL;
    this.infoText = infoText;
    this.attributes = attributes;
    this.productRelationshipGroups = productRelationshipGroups;
    this.externalId = externalId;
    this.flippingAxis = flippingAxis;
    this.basePrice = basePrice;
    this.movementData = movementDatas;
    this.tlorisPlaceholderIcon = tlorisPlaceholderIcon;
    this.collisionDescriptors = collisionDescriptors;
    this.rotateStep = rotateStep;
    this.possibleRotations = possibleRotations;
    this.builderName = builderName;
    this.jsonData = jsonData;
    this.utilityIds = utilityIds;
    this.parameters = parameters;
    this.status = status;
    this.receiptSettings = receiptSettings;
    this.productBlueprintVisibility = productBlueprintVisibility;
  }
}
